export default "__VITE_ASSET__B1J0zxfH__"